import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useUserEventLogger } from '@repo/tracking-service';
import { Drawer, DrawerBody, DrawerContent, DrawerHeader, List } from '@repo/ui';

import { INFOTECH_BANK } from '@/lib/constants/bank';

const BankListDrawer = NiceModal.create(({ onClick }: { onClick: (bankId: string) => void }) => {
  const { visible, hide } = useModal();
  const { pageName, sendClickEvent, sendViewEvent } = useUserEventLogger();

  sendViewEvent(`${pageName}_bankaccount_bank-list`, undefined, { isAllowRetry: true });

  const handleClose = () => {
    sendClickEvent(`${pageName}_bankaccount_bank-list_bank-list-close`);

    hide();
  };

  return (
    <Drawer open={visible} onOpenChange={handleClose}>
      <DrawerContent>
        <DrawerHeader className={'heading-small-bold'}>은행을 선택해주세요</DrawerHeader>
        <DrawerBody className={'!pt-tiny-large'}>
          {INFOTECH_BANK?.map(({ bankId, bankName, bankIconFileName }) => {
            return (
              <List
                key={bankId}
                leadingElement={
                  <img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/common/logo/external/${bankIconFileName}.svg`} className={'w-9 h-9'} alt={''} />
                }
                title={bankName}
                primaryAction
                onClick={() => {
                  sendClickEvent(`${pageName}_bankaccount_bank-list_select-bank`, {
                    item: bankName
                  });
                  onClick(bankId);
                }}
              />
            );
          })}
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
});

export default BankListDrawer;
